import { TrendingUp } from 'lucide-react';

export function FutureOfSurgicalFinance() {
  return (
    <section className="py-20 md:py-28 bg-secondary">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
          Looking Ahead
        </p>

        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground leading-tight mb-6">
          The hospital of the future cannot afford the leak of the past.
        </h2>

        <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
          As margins shrink and payer scrutiny increases, "Closed-Loop" logic is
          no longer a luxury — it is a requirement for survival. LINK is the
          bridge to that future.
        </p>
      </div>
    </section>
  );
}
